export const unmodule = (x) => x?.default ?? x;

export const getCsrfToken = () => {
  const csrfTokenElement = document.head.querySelector(
    'meta[name="csrf-token"]',
  );
  return csrfTokenElement.content;
};

const buildOrderHistoryKey = (buildingCode) =>
  `hebe_hgs_orders_${buildingCode || "default"}`;

const buildWebPushSubscriptionIdKey = (buildingCode) =>
  `hebe_web_push_subscription_id_${buildingCode || "default"}`;

export const getStoredWebPushSubscriptionId = (buildingCode) => {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem(buildWebPushSubscriptionIdKey(buildingCode));
  } catch (_e) {
    return null;
  }
};

export const setStoredWebPushSubscriptionId = (buildingCode, id) => {
  if (typeof window === "undefined" || id == null) return;
  try {
    localStorage.setItem(
      buildWebPushSubscriptionIdKey(buildingCode),
      String(id),
    );
  } catch (_e) {
    console.error("[ERROR] Failed to set stored web push subscription id", _e);
  }
};

export const getOrderHistoryFromLocal = (buildingCode) => {
  if (typeof window === "undefined") return [];

  try {
    const raw = localStorage.getItem(buildOrderHistoryKey(buildingCode));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (_e) {
    return [];
  }
};

export const saveOrderToLocalHistory = ({
  buildingCode,
  order,
  kind = "fnb",
}) => {
  if (typeof window === "undefined" || !order?.id) return;

  const existing = getOrderHistoryFromLocal(buildingCode);
  const next = [
    {
      id: order.id,
      kind: order.kind || kind,
      order_number: order.order_number || null,
      created_at: order.created_at || new Date().toISOString(),
    },
    ...existing.filter((entry) => entry?.id !== order.id),
  ].slice(0, 30);

  localStorage.setItem(
    buildOrderHistoryKey(buildingCode),
    JSON.stringify(next),
  );
};

// The "My Order" list mixes F&B and add-on orders; the entry's kind selects the right API endpoint.
export const orderApiPath = (entry) =>
  entry?.kind === "add_on"
    ? `/api/v1/add_on_orders/${entry.id}`
    : `/api/v1/orders/${entry.id}`;

export const getOrderKindFromLocal = (buildingCode, id) => {
  const entry = getOrderHistoryFromLocal(buildingCode).find(
    (e) => e?.id === id,
  );
  return entry?.kind || "fnb";
};

export const addThousandSeparator = (value) => {
  if (value === "") {
    return;
  }
  value = value.replace(/\D/g, "");

  let valueCommaToken = value.toString().split(",");

  let valueBeforeComma = processValueBeforeComma(valueCommaToken[0]);
  let valueAfterComma = processValueAfterComma(valueCommaToken[1], value);

  return `${valueBeforeComma}${valueAfterComma}`;
};

const processValueBeforeComma = (value) => {
  let valuesBeforeComma = removeSeparatorNumber(value);

  let tempLengthRunning = valuesBeforeComma.length;
  for (let i = 0; tempLengthRunning > 3; i++) {
    tempLengthRunning -= 3;
    valuesBeforeComma.splice(tempLengthRunning, 0, ".");
  }

  return valuesBeforeComma.join("");
};

const processValueAfterComma = (value, currentValue) => {
  let result = value;

  if (result) {
    return `,${result}`;
  }

  if (currentValue[currentValue.length - 1] === ",") {
    return ",";
  }

  return "";
};

const removeSeparatorNumber = (number) => {
  let result = [];

  let token = number.split("");
  for (let i = 0; i < token.length; i++) {
    if (token[i] === ".") {
      continue;
    }

    result.push(token[i]);
  }

  return result;
};
